import { DialogActions } from "@remo-co/ui-core/src/components/DialogActions";
import { Button } from "@remo-co/ui-core/src/components/Button";
import { useI18n } from "i18n";
import { useStyles } from "./DialogFooter.styles";

interface IDialogFooterProps {
  isEditMode: boolean;
  handleClose: () => void;
  handleSubmit: () => void;
  loading: boolean;
}

const DialogFooter = ({
  isEditMode,
  handleClose,
  handleSubmit,
  loading,
}: IDialogFooterProps) => {
  const styles = useStyles();
  const { t } = useI18n(["eventDirectory"]);

  return (
    <DialogActions className={styles.actions}>
      <Button
        color="dark"
        size="md"
        variant="secondary"
        loading={loading}
        disabled={loading}
        onClick={handleSubmit}
        data-testid="create-event-directory"
      >
        {isEditMode
          ? t("eventDirectory:save.event.directory")
          : t("eventDirectory:create.event.directory")}
      </Button>
      {isEditMode && (
        <Button
          color="blue"
          size="md"
          variant="tertiary"
          disabled={loading}
          onClick={handleClose}
        >
          {t("common:button.cancel")}
        </Button>
      )}
    </DialogActions>
  );
};

export default DialogFooter;
